import { useEffect, useState } from "react";
import SEOHead from "../components/SEOHead";
import LocationCard from "../components/LocationCard";
import MapWidget from "../components/MapWidget";
import NearMeSearch from "../components/NearMeSearch";
import { getLocations } from "../lib/api";

export default function LocationsList() {
    const [locations, setLocations] = useState([]);

    useEffect(() => {
        getLocations().then(setLocations);
    }, []);

    return (
        <>
            <SEOHead
                title="All ZenZest Dispensary Locations in NY"
                description="ZenZest Cannabis storefronts in Queens / Nassau Long Island and Staten Island. NY OCM-licensed adult-use dispensaries with same-day delivery."
                canonical="https://weeddispensarynearme.com/locations"
            />

            <section className="border-b border-zen-ink/8 bg-zen-bg">
                <div className="max-w-[1400px] mx-auto px-6 sm:px-10 py-12 sm:py-16">
                    <p className="text-[11px] uppercase tracking-[0.35em] text-zen-olive mb-6">
                        Directory
                    </p>
                    <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-light text-zen-ink leading-[0.95] tracking-tight max-w-3xl">
                        ZenZest dispensaries{" "}
                        <span className="italic text-zen-olive">in NY.</span>
                    </h1>
                    <p className="mt-8 max-w-2xl text-lg text-zen-ink-soft leading-relaxed">
                        Two flagship locations. 80+ neighborhoods served. Pick
                        your store below — or search by ZIP to find your closest
                        legal dispensary.
                    </p>
                    <div className="mt-12">
                        <NearMeSearch />
                    </div>
                </div>
            </section>

            <section className="max-w-[1400px] mx-auto px-6 sm:px-10 py-14">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-16">
                    {locations.map((loc) => (
                        <LocationCard key={loc.slug} location={loc} />
                    ))}
                </div>
                <MapWidget
                    locations={locations}
                    center={[40.69, -73.93]}
                    zoom={10}
                    height={520}
                />
            </section>
        </>
    );
}
